import { useTranslations } from 'next-intl'

import {
  AdditionalOption,
  OldAdditionalOption,
  TRoomDetail,
} from '@/entities/room'
import { cn } from '@/shared/lib'
import { Button, Icon } from '@/shared/ui'

import { OptionDrawerTrigger } from './option-drawer'
import { OptionList } from './option-list'
import { getOptionData } from '../../../lib/option'
import { Heading } from '../../common'

export type Props = Pick<TRoomDetail, 'basicOptions' | 'missingOptions'> & {
  additionalOptions: (AdditionalOption | OldAdditionalOption)[]
}

export const MobileRoomOption = ({
  basicOptions,
  additionalOptions,
  missingOptions,
}: Props) => {
  const t = useTranslations('room_detail')

  const { slicedOptions, totalCount, hasBasicOptions, hasAdditionalOptions } =
    getOptionData({ basicOptions, additionalOptions })

  return (
    <section className="space-y-6 px-4 py-10">
      <div className="space-y-10">
        {hasBasicOptions && (
          <div className={cn('space-y-4')}>
            <Heading size="small">{t('basic_option.title')}</Heading>
            <OptionList className="gap-x-10" options={basicOptions} />
          </div>
        )}

        {hasAdditionalOptions && (
          <div className="space-y-4">
            <Heading size="small">{t('additional_option.title')}</Heading>
            <OptionList className="gap-x-10" options={slicedOptions} />
          </div>
        )}
      </div>

      <OptionDrawerTrigger
        basicOptions={basicOptions}
        additionalOptions={additionalOptions}
        missingOptions={missingOptions}
      >
        <Button fullWidth size="large" variant="outline">
          {t('option.button.view_all', { count: totalCount })}
          <Icon name="arrow-right" size={16} />
        </Button>
      </OptionDrawerTrigger>
    </section>
  )
}
